import Button from 'components/Button/Button';
import { useUserRolePermissionStore } from 'contexts/RootStore.context';
import { useState } from 'react';
import styled from 'styled-components';
import { DownloadUserLogsModal } from './DownloadUserLogsModal';

const StyledButtonContainer = styled.div`
  margin-right: 10px;
`;

type DownloadLogsProps = {
  disabled: boolean
}
export default function DownloadLogs(props: DownloadLogsProps) {
  const [openDownloadModal, setOpenDownloadModal] = useState(false);
  const { canReportUsers } = useUserRolePermissionStore()

  const handleDownloadLog = () => {
    setOpenDownloadModal(true);
  };

  if (!canReportUsers) {
    return <></>
  }

  return (
    <StyledButtonContainer>
      <Button
        id="download-logs-button"
        style={{ width: '200px' }}
        outline
        disabled={props.disabled}
        onClick={handleDownloadLog}
      >
        Download Custom Log
      </Button>
      {openDownloadModal && <DownloadUserLogsModal onClose={() => setOpenDownloadModal(false)} />}
    </StyledButtonContainer>
  );
}
